import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'
import { RadioProps } from '@ui/components/Radio'

import { ClientPhoneNumberDto } from '@model/AccountDetailedDto'

interface Props {
  phoneNumbers: ClientPhoneNumberDto[]
  selectedPhone?: string
  onConfirm: (phone: string) => void
  onClose?: () => void
}

export const TwoFactorAuthenticationSelectPhoneModal: BaseModalType<Props> = ({
  close,
  phoneNumbers,
  selectedPhone = '',
  onConfirm,
  onClose,
}) => {
  const { t } = useTranslation()
  const [value, setValue] = React.useState(selectedPhone)

  const options: RadioProps[] = phoneNumbers.map((p) => ({
    label: `${p.countryCode} ${p.number}`,
    value: `${p.countryCode}${p.number}`,
  }))

  const handleCancel = () => {
    onClose?.()
    close()
  }

  const handleConfirm = () => {
    if (!value) return
    onConfirm(value)
    close()
  }

  return (
    <Modal>
      <Modal.Header>{t('Profile.2FA for Log in')}</Modal.Header>
      <Modal.Body>
        <Modal.Body.Input.Radio
          name='phoneSelect'
          value={value}
          options={options}
          onChange={(v: string) => setValue(v)}
        />
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={handleCancel}>{t('Cancel')}</Modal.Footer.Secondary>
        <Modal.Footer.Primary onClick={handleConfirm} disabled={!value}>
          {t('Confirm')}
        </Modal.Footer.Primary>
      </Modal.Footer>
    </Modal>
  )
}
